const translations = {
  logout: 'Logout',
  openMenu: 'Open Menu',
  closeMenu: 'Close Menu',
  author: 'Posted by',
  'add-review': 'Mmm! Share your food story!',
  'add-review-to-food': 'Tell us about your {{food}} experience',
  comments: {
    title: 'Comments',
    subtitle: 'Join the conversation',
    writeComment: 'Write a comment...',
    placeholder: 'Write a comment...',
    submit: 'Post',
    delete: 'Delete',
    noComments: 'No comments yet. Be the first to comment!',
    loginToComment: 'Please log in to leave a comment',
    loadMore: 'Load more',
    commentAdded: 'Comment added successfully',
    commentError: 'Failed to add comment',
    commentDeleted: 'Comment deleted',
    deleteError: 'Failed to delete comment',
    post: 'Post'
  },
  food: {
    title: 'Food',
    gourmets: '{{food}} Fans',
    bestPlaces: 'Best Spots for {{food}}',
    gourmetsSectionDescription:
      "Check out who knows their {{food}}! Our foodies are ranked by how many times they've tried it and what they thought.",
    bestPlacesSectionDescription:
      'Looking for amazing {{food}}? These spots are rated by people who know their stuff!',
    beTheFirstReviewer: {
      title: 'Be the First to Review {{foodName}}!',
      description: 'Your taste experience matters! Share your review and help fellow foodies discover this dish.',
      button: 'Write the First Review'
    }
  },
  drink: 'Drink',
  place: 'Spot',
  'where-did-you-eat': "Where'd you grab this?",
  'what-did-you-eat': "What'd you try?",
  localeCurrency: 'Local Currency',
  category: 'Category',
  name: 'Name',
  rating: 'Your Score',
  welcome_modal: {
    title: 'Welcome to BiteCritic!',
    subtitle: 'Discover Your Next Favorite Bite',
    description:
      "BiteCritic is a community of food lovers who share their experiences and rate the food they've tried.",
    features: {
      title: 'With BiteCritic, you can:',
      rate: 'Rate dishes based on taste, not just restaurants',
      discover: 'Discover new foods based on authentic reviews',
      connect: 'Connect with other food enthusiasts',
      track: 'Track foods you want to try',
    },
    not_now: 'Not Now',
    join_now: 'Join Now',
  },
  review: {
    label: 'Your Take',
    writingIn: 'I am writing this review in',
    success: 'Your story is live!',
    error: 'Oops! Something went wrong sharing your story',
    foodReviewTitle:
      '{{foodName}} review by {{username}} at {{placeName}}, {{city}}',
    drinkReviewTitle:
      '{{drinkName}} review by {{username}} at {{placeName}}, {{city}}',
  },
  previous: 'Back',
  next: 'Next',
  'submit-review': 'Share Your Story',
  cancel: 'Never Mind',
  type: 'What Kind',
  'add-food-review': "What'd you eat?",
  'select-food': 'Pick your dish',
  cost: 'How Much?',
  'rating-explanation': 'Rate it! (1 = meh, 10 = mind-blowing!)',
  'write-your-review': 'Your review on the taste not the restaurant. Make it honest and helpful.',
  'visited-at': "When'd you go?",
  reviews: {
    noReviews: 'No reviews found',
    readFull: 'Read the whole story',
    showTranslation: 'Show translation',
    showOriginal: 'Show original',
    translatedFrom: 'Translated from {{language}}',
    filters: {
      title: 'Filters',
      apply: 'Apply Filters',
      rating: 'Rating',
      cost: 'Cost',
      startDate: 'From',
      endDate: 'To',
      location: 'Location',
      radius: 'Search Radius (km)',
      sort: {
        label: 'Sort by',
        newest: 'Newest First',
        oldest: 'Oldest First',
        mostLiked: 'Highest Rated',
        leastLiked: 'Lowest Rated',
        mostExpensive: 'Most Expensive',
        cheapest: 'Cheapest',
      },
      sortOrder: {
        asc: 'ascending',
        desc: 'descending',
      },
      sortBy: {
        createdAt: 'Date',
        likeCount: 'Likes',
        cost: 'Price',
      },
      active: {
        rating: 'Min Rating: {{value}}',
        startDate: 'From: {{date}}',
        endDate: 'To: {{date}}',
        cost: 'Min Cost: {{value}}',
        radius: 'Within {{value}}km',
      },
    },
  },
  languages: {
    en: 'English',
    nl: 'Dutch',
    tr: 'Turkish',
    de: 'German',
    fr: 'French',
    es: 'Spanish',
    it: 'Italian',
    pt: 'Portuguese',
    select: 'Select language',
  },
  validation: {
    'place-required': 'Oops! Pick a place first',
    'category-required': 'Pick a category!',
    'review-min-length':
      'A bit more detail would be great (at least 80 characters)',
    'rating-required': "Don't forget to rate it!",
    'cost-positive': 'Price needs to be more than zero',
    'visited-at-required': 'When did you go?',
    'type-required': 'Food or drink?',
    'food-required': 'What did you eat?',
    'drink-required': 'What did you drink?',
    'country-required': 'Where are you from?',
    required: 'This field is required',
  },
  auth: {
    welcomeBack: 'Hey There! 👋',
    loginToContinue: 'Jump back in',
    continueWithGoogle: 'Continue with Google',
    continueWithApple: 'Continue with Apple',
    logout: 'Catch You Later!',
    login: 'Sign In',
    signup: 'Sign Up',
    signupToContinue: 'Join our foodie community',
    joinCommunity: 'Join Our Food Community',
    required: "Let's Get You Started!",
    actionRequiresAuth: 'Oops! Quick login needed for that',
    alreadyLoggedIn: "You're already logged in!",
    goToProfile: 'Go to Profile',
    continueToFeed: 'Continue to Feed',
    alreadyHaveAccount: 'Already have an account?',
    benefits: {
      title: "Look what you're missing out on:",
      follow: 'Keep track of your fave foods',
      review: 'Share your food adventures',
      save: 'Bookmark spots for later',
      community: 'Meet other food lovers',
      personalized: 'Get food tips just for you',
    },
    cta: {
      login: "Let's Go!",
      cancel: 'Maybe Later',
    },
    actions: {
      followFood: 'Quick login to follow this yummy dish!',
      unfollowFood: 'Login to unfollow',
    },
    joinNow: 'Join Now!',
  },
  profile: {
    follow: 'Follow',
    unfollow: 'Unfollow',
    followers: 'Fans',
    following: 'Following',
    avatar: 'Your Pic',
    change_avatar: 'New Pic',
    upload_avatar: 'Upload Pic',
    title: 'Your Profile',
    view: 'Check Profile',
    username: 'Username',
    email: 'Email',
    success: 'Looking good!',
    error: 'Oops, something went wrong',
    save: 'Save It',
    firstName: 'First Name',
    lastName: 'Last Name',
    birthDate: 'Birthday',
    country: 'Country',
    bio: 'About You',
    noAccount: "Don't have an account yet?",
    bioPlaceholder: 'Tell us about your food adventures...',
    selectCountry: 'Select Your Country',
    deleteAccount: {
      button: 'Delete Account',
      title: 'Delete Your Account',
      warning:
        'Warning: This action cannot be undone. All your user data and preferences will be permanently deleted.',
      confirm: 'Delete My Account',
      error: 'Failed to delete account. Please try again later.',
    },
  },
  errors: {
    invalidFileType:
      'Invalid file type. Please upload only JPG, PNG, WebP, HEIC, or HEIF images.',
    fileTooLarge: 'File is too large. Maximum size is {{size}}.',
    tooManyFiles: 'Too many files. Maximum allowed is {{max}}.',
  },
  onboarding: {
    welcome: 'Welcome to BiteCritic!',
    setup_profile: "Let's set up your profile for {{email}}",
    username: 'Username',
    username_required: 'Username is required',
    username_min_length: 'Username must be at least 3 characters',
    username_pattern: 'Only letters, numbers and underscore are allowed',
    username_taken: 'This username is already taken',
    username_available: 'Username is available!',
    username_requirements:
      'Username must be at least 3 characters and can only contain letters, numbers and underscore',
    checking_username: 'Checking username availability...',
    first_name: 'First Name',
    first_name_required: 'First name is required',
    first_name_min_length: 'First name must be at least 2 characters',
    first_name_max_length: 'First name must be at most 20 characters',
    last_name: 'Last Name',
    last_name_required: 'Last name is required',
    last_name_min_length: 'Last name must be at least 2 characters',
    last_name_max_length: 'Last name must be at most 20 characters',
    birth_date: 'Birth Date',
    birth_date_required: 'Birth date is required',
    country: 'Country',
    complete_profile: 'Complete Profile',
    success: 'Profile updated successfully!',
    error: 'Failed to update profile',
  },
  language: {
    select: 'Pick Your Language',
    select_country: 'Where Are You?',
    select_language: 'Which Language?',
    current: 'Current Language',
  },
  categories: {
    title: 'Food Categories',
    meta: {
      title: 'Food Categories - Discover Culinary Delights',
      description:
        'Explore our diverse food categories and discover culinary delights from around the world. Find reviews, ratings, and where to enjoy them.',
      categoryTitle: 'Food Category',
      categoryDescription:
        'Explore {{category}} - Find {{count}} delicious dishes in this category with reviews from food lovers.',
      keywords:
        'food categories, cuisine types, culinary exploration, food discovery',
      loading: 'Loading Category',
      defaultDescription:
        'Explore our diverse food categories and find your next culinary adventure.',
    },
  },
  common: {
    noMoreReviews: 'No more reviews',
    save: 'Save',
    error: {
      default: 'Oops!',
      fetchFailed: 'Failed to fetch data',
      rateLimitExceeded: 'Too many requests. Please wait a moment and try again.',
    },
    deleteMedia: 'Delete Media',
    uploadedMedia: 'Media Uploaded',
    comingSoon: 'Coming Soon',
    notNow: 'Not Now',
    close: 'Close',
    saveChanges: 'Save Changes',
    food: 'food',
    previous: 'Previous',
    search: 'Search',
    back: 'Back',
    cancel: 'Cancel',
    loading: 'Loading...',
    delete: 'Delete',
    create: 'Create',
    open: 'Open',
    closed: 'Closed',
    country: 'Country',
    reviews: 'Reviews',
    reviews_count: '{{count}} gourmets have tried this',
    showMore: 'Show More',
    showLess: 'Show Less',
    uploadImage: 'Upload Image',
    uploadMedia: 'Upload Media',
    sort: 'Sort By',
    loadMore: 'Load More',
    backToHome: 'Back to Home',
    next: 'Next',
    actions: {
      share: {
        label: 'Share',
        copied: 'Link copied to clipboard',
        copyFailed: 'Failed to copy link',
      },
    },
    exploreMore: 'Explore More',
    discoverExperiences: 'Discover new culinary experiences',
    reachedEndOfContent: "You've reached the end of this content",
  },
  statuses: {
    active: 'Active',
    pending: 'Pending',
    rejected: 'Rejected',
  },
  places: {
    radius: 'Search Radius (km)',
    noPlacesFound: 'Nothing here yet',
    tryAdjustingFilters: 'Try searching for a place or adjusting filters to see more options.',
    locationPermission: {
      title: 'Where would you like to explore?',
      description: 'Enable location to find great places nearby or search for a specific location.',
      allow: 'Use My Location'
    },
    whereDidYouEat: 'Where did you eat this?',
    searchByLocation: 'Where do you want to go?',
    selectPlace: 'Search for a place...',
    yourLocation: 'Your Location',
    searchOrUseLocation: 'Search for a place or use your location to get started.',
    locationStatus: {
      detecting: 'Finding your location...',
      denied: 'Location access denied',
      unavailable: 'Location unavailable',
      found: 'Location found!'
    },
    sort: {
      title: 'Sort By',
      ratingDesc: 'Highest Rated', 
      ratingAsc: 'Lowest Rated',
      distanceAsc: 'Nearest First',
      distanceDesc: 'Furthest First',
      nameAsc: 'Name (A-Z)',
      nameDesc: 'Name (Z-A)',
      reviewCountDesc: 'Most Reviewed',
      reviewCountAsc: 'Least Reviewed',
      newestFirst: 'Newest First',
      oldestFirst: 'Oldest First'
    },
    period: {
      title: 'Time Period',
      ALL_TIME: 'All Time',
      LAST_WEEK: 'Last Week',
      LAST_MONTH: 'Last Month',
      LAST_YEAR: 'Last Year'
    },
    meta: {
      title: 'Discover Restaurants Near You',
      description: 'Find and explore the best restaurants in your area. Read reviews, see photos, and discover new dining experiences.',
      titleWithPlace: 'Best Places Near {{place}}',
      descriptionWithPlace: 'Discover the best restaurants and food spots near {{place}} within {{radius}}km. Read reviews, see ratings, and find your next favorite place to eat.'
    },
    navigation: {
      title: 'Places',
    },
    detail: {
      error: "Oops! We couldn't find that place. Try again?",
      sections: {
        popularFoods: {
          title: 'Most Loved at {{place}}',
          description:
            'These dishes are most appreciated by our foodie community at {{place}}. Ranked by ratings and number of reviews.',
          titleWithCity: 'Most Loved at {{place}} in {{city}}',
          descriptionWithCity:
            'These dishes are most appreciated by our foodie community at {{place}} in {{city}}. Ranked by ratings and number of reviews.',
        },
        gourmets: {
          title: 'Top Foodies at {{place}}',
          description:
            'Meet the food lovers who know {{place}} best. They are ranked by their number of reviews and ratings.',
          titleWithCity: 'Top Foodies at {{place}} in {{city}}',
          descriptionWithCity:
            'Meet the food lovers who know {{place}} in {{city}} best. They are ranked by their number of reviews and ratings.',
        },
        reviews: {
          title: 'Reviews at {{place}}',
          titleWithCity: 'Reviews at {{place}} in {{city}}',
        },
      },
    },
    emptyState: {
      title: 'No places found',
      description: '{{username}} hasn\'t reviewed any places yet.'
    },
    userMapTitle: '{{username}}\'s Food Map',
    reviewsDrawer: {
      title: '{{placeName}} Reviews',
      noReviews: 'No reviews for this place yet.',
      viewMore: 'View all reviews',
      addReview: 'Add review'
    },
    viewAllVisited: 'All places {{username}} visited and rated'
  },
  settings: {
    title: 'Your Settings',
  },
  home: 'Home',
  'review-not-found': "Can't find this review",
  'go-back': 'Go back',
  actions: {
    share: 'Tell friends',
  },
  feed: {
    title: 'Your Personal Culinary Journey',
    description:
      'Follow your favorite foods, places, and gourmets for your perfect food feed. Get personalized recommendations and never miss a good meal.',
    discover: 'Start Exploring',
    personalizedTitle: 'Your Food Feed',
    allReviewsTitle: 'Latest Food Stories',
    personalizedDescription:
      'See reviews from foods, places, and gourmets you follow.',
    joinCommunityDescription:
      'Join our community to get a personalized feed based on your interests.',
    noRelatedReviews:
      "We don't have reviews matching your interests yet. Let's check out some global stories!",
    showGlobalFeed: 'View Global Feed',
    myFeed: 'My Feed',
    globalFeed: 'Global Feed',
    globalDescription: 'Discover the latest food stories from around the world.',
    noGlobalReviews:
      'No global reviews are available right now. Check back soon!',
    meta: {
      title: 'Your Personalized Food Feed',
      description:
        'Your personalized food feed with reviews from foods, places, and gourmets you follow.',
      keywords: 'food feed, personalized recommendations, food stories, reviews',
    },
    followFoods: {
      title: 'Follow Your Favorite Foods',
      description: 'Follow your favorite foods to see reviews in your feed.',
    },
    followPlaces: {
      title: 'Follow Your Favorite Places',
      description: 'Follow your favorite places to see reviews in your feed.',
    },
    followGourmets: {
      title: 'Follow Gourmets',
      description: 'Follow gourmets to see their reviews in your feed.',
    },
  },
  app: {
    actions: 'App Actions',
  },
  download: {
    ios_app: 'Download iOS App',
    android_app: 'Download Android App',
  },
  users: {
    title: 'Food Enthusiasts',
    searchPlaceholder: 'Search by name...',
    noResults: 'No food enthusiasts found',
    seoTitle: 'Food Critics and Reviewers',
    seoDescription:
      'Discover food critics and reviewers in your area. Connect with foodies who share your culinary passions and discover new taste experiences.',
    seoKeywords: 'food critics, food reviewers, culinary experts, foodies, gourmets',
    navigation: {
      title: 'Foodies',
    },
    stats: {
      followers: 'Followers',
      following: 'Following',
      rating: 'Rating',
      reviews: 'Reviews',
    },
    map: {
      viewMap: 'View Food Map',
      seoTitle: '{{username}}\'s Food Map',
      seoDescription: 'Explore the places {{username}} has visited and reviewed on their Food Map.'
    },
    detail: {
      sections: {
        visitedPlaces: {
          title: '{{username}}\'s Recently Visited Places',
          description:
            'Places where {{username}} has shared culinary experiences',
        },
        likedFoods: {
          title: '{{username}}\'s Favorite Foods',
          description: 'Foods that {{username}} has tried and reviewed',
        },
      },
    },
  },
  foods: {
    title: 'Foods',
    meta: {
      title: 'Discover Foods Near You',
      description:
        'Explore and discover delicious foods in your area. Browse reviews, ratings, and photos of various dishes from local restaurants.',
    },
    searchPlaceholder: 'Search foods...',
    noResults: 'No foods found',
    sort: {
      nameAsc: 'Name A-Z',
      nameDesc: 'Name Z-A',
      ratingDesc: 'Highest Rating',
      ratingAsc: 'Lowest Rating',
      reviewCountDesc: 'Most Reviews',
      reviewCountAsc: 'Least Reviews',
    },
    period: {
      allTime: 'All Time',
      lastWeek: 'Last Week',
      lastMonth: 'Last Month',
      lastYear: 'Last Year',
    },
  },
  navigation: {
    home: 'Home',
    discover: 'Discover',
    popular: 'Popular',
    community: 'Community',
    placesNearMe: 'Places Near Me',
    foodsNearMe: 'Foods Near Me',
    popularFoodsMonth: "Month's Popular Foods",
    popularPlacesMonth: "Month's Top-Rated Places",
    mostReviewedPlacesMonth: "Month's Most Reviewed Places",
    myFeed: 'My Feed',
    myProfile: 'My Profile',
    popularGourmetsMonth: "Month's Popular Gourmets",
    support: 'Support',
    contact: 'Contact',
    gourmets: 'Find Gourmets',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
  },
  error: {
    pageNotFound: 'Page Not Found',
    pageNotFoundDescription:
      'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.',
    needHelp: 'Need Help?',
    contactUs:
      'Contact our support team and we will help you find what you are looking for.',
  },
  contact: {
    title: 'Contact Us',
    name: 'Your Name',
    email: 'Email Address',
    message: 'Message',
    send: 'Send Message',
    nameRequired: 'Please enter your name',
    emailRequired: 'Please enter your email',
    emailInvalid: 'Please enter a valid email',
    messageRequired: 'Please enter your message',
    pageTitle: 'Get in Touch',
    pageDescription:
      'Have questions or need assistance? We are here to help! Fill out the form below or email us directly.',
  },
  seo: {
    keywords: {
      food: 'food',
      cuisine: 'cuisine',
      reviews: 'reviews',
      rating: 'rating',
      restaurants: 'restaurants',
      dining: 'dining',
    },
    food: {
      title: '{{foodName}} Review',
      description:
        'Discover the best places to eat {{foodName}}. Read honest reviews and find out where to enjoy the most delicious {{foodName}} near you on BiteCritic.',
      defaultDescription:
        'Discover {{foodName}} - reviews, ratings, and where to find the best {{foodName}} near you.',
    },
    place: {
      defaultDescription:
        'Explore {{placeName}} - reviews, ratings, and popular dishes at this place.',
      cityDescription:
        'Explore {{placeName}} in {{cityName}} - reviews, ratings, and popular dishes at this place.',
    },
    review: {
      defaultDescription:
        'Read {{username}}\'s review of {{foodName}} at {{placeName}} - ratings, photos, and detailed experience.',
      foodTitle: '{{foodName}} Review at {{placeName}} - {{rating}}/10',
      placeTitle: '{{placeName}} Review - {{rating}}/10',
      metaDescription:
        'Read {{username}}\'s detailed review of {{foodName}} at {{placeName}}. Rating: {{rating}}/10. Discover what makes this {{type}} special.',
      authorTitle: '{{username}}\'s Review of {{foodName}} at {{placeName}}',
      ratingScale: 'Rating scale: 0-10',
      reviewedType: {
        food: 'dish',
        restaurant: 'restaurant',
        product: 'product',
      },
    },
    user: {
      defaultDescription:
        'Discover {{username}}\'s culinary journey - reviews, favorite foods, and culinary adventures.',
    },
    category: {
      defaultDescription:
        'Explore {{categoryName}} foods - discover the best dishes, reviews, and where to find them near you.',
    },
    meta: {
      siteName: 'BiteCritic',
      defaultTitle: 'BiteCritic - Discover and Share Food Experiences',
      defaultDescription:
        'Join food lovers around the world to discover and share amazing culinary experiences. Find authentic reviews, ratings, and photos of dishes near you.',
      defaultKeywords:
        'food, restaurants, reviews, dining, cuisine, food critics',
    },
  },
  endOfScroll: {
    placesNearMe: 'Places Near Me',
    placesNearMeSubtitle: 'Find restaurants and venues in your area',
    globalFeed: 'Global Feed',
    globalFeedSubtitle: 'See what others are enjoying',
    findPeople: 'Find Foodies',
    findPeopleSubtitle: 'Connect with other food enthusiasts',
    foodsNearMe: 'Foods Near Me',
    foodsNearMeSubtitle: 'Discover popular dishes in your area',
  },
  notifications: {
    title: 'Notifications',
    pageTitle: 'Notifications',
    pageDescription: 'Manage your notifications',
    markAllAsRead: 'Mark all as read'
  },
  mentions: {
    noUsersFound: 'No users found',
    searchingUsers: 'Searching users...',
  },
  'location': 'Location',
  'review-modal-media-explanation': 'Take a photo or pick one from your album to showcase your dish!',
  'review-modal-rating-explanation': 'How did it taste? Give your honest assessment.',
  'review-modal-location-explanation': 'Where did you enjoy this dish? Let others know!',
  'draft-cleared': 'Draft cleared successfully!',
  'draft-save-error': 'Oops! Unable to save your draft',
  'clear-draft': 'Clear draft',
  'media': 'Media',
  'media.image': 'Image',
  'media.video': 'Video',
};

// Create a recursive type that makes all properties optional
type RecursivePartial<T> = {
  [P in keyof T]?: T[P] extends (infer U)[]
    ? RecursivePartial<U>[]
    : T[P] extends object
    ? RecursivePartial<T[P]>
    : T[P];
};

// Export the full type from the base translations
export type BaseTranslation = typeof translations;

// Export a partial version for other languages
export type Translation = RecursivePartial<BaseTranslation>;

export default translations;
